import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from "../../../Transcript/SchedulePDFStyles"
import { formattedStartAndEndDate, formattedDate } from '../../../Transcript/SchedulePDFUtils';

const SchedulePDFEachPageFooter = ({ minDate, maxDate }) => (
   
     <View style={styles.footer}>
      {/* Disclaimer */}
      {/* <Text style={[styles.footerText, { textAlign: 'left', width: '100%',marginBottom: 0 }]}>
        ‡Disclaimer: This transcript has captured completed training since the launch of the Caregiver Learning Center on {formattedStartAndEndDate(minDate)}  to {formattedStartAndEndDate(maxDate)}, along with On-The-Job credits granted per WAC 388-71-0992. Training taken before the launch of the Caregiver Learning Center can be requested and produced in a separate transcript file from SEIU 775 Benefits Group.
      </Text> */}
  
     
      
       <View style={styles.footereachpageColumn1}> 
        <Text style={styles.leftText}> Generated on: {formattedDate}  </Text>
       </View>
      <View style={[styles.footereachpageColumn2, {  alignSelf: "flex-end" }]}> 
       <Text
        style={[styles.footerText, {  alignSelf: 'flex-end' }]}
        render={({ pageNumber, totalPages }) =>
          `Page ${pageNumber} of ${totalPages}`
        }
        fixed
      />
       </View> 
    </View>
);

export default SchedulePDFEachPageFooter;
